// modules
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { addModal } from 'weblite-web-modal-viewer'
// component
import { WappProfileMenu } from './wapp-profile-menu'

const COMPONENT_ID = 'wappProfileMenu'

interface Prop {
  wappId: string
}

export const showWappProfileMenu = (props: Prop, preventBackClick = false) =>
  addModal({ id: COMPONENT_ID, props, preventBackClick })

export default {
  [COMPONENT_ID]: { Component: WappProfileMenu },
}
